<ag-dynamic-form
  *ngIf="metadataTop"
  [metadata]="metadataTop"
  [model]="student?.dynamicData"
  (validated)="valid = $event"
></ag-dynamic-form>

<ag-dynamic-form
  *ngIf="metadataAIInterview"
  [metadata]="metadataAIInterview"
></ag-dynamic-form>

<ag-dynamic-form
  *ngIf="metadataBottom"
  [metadata]="metadataBottom"
  [model]="student?.dynamicData"
  (validated)="valid = $event"
></ag-dynamic-form>

<div class="footer" *ngIf="!readonly">
  <div class="footer__container">
    <button
      class="footer__btn footer__btn--blue"
      [disabled]="!valid"
      (click)="save()"
    >
      更新
    </button>
  </div>
</div>

<ng-template #examResultRegistrationGPS>
  <div class="ai-interview-button-group">
    <button class="btn btn--green btn--header" (click)="importCSVGPS()">
      CSV取り込み
    </button>
    <button class="btn btn--green btn--header" (click)="registerExamResultGPS()">
      受検結果登録
    </button>
  </div>
</ng-template>

<ng-template #examResultRegistrationPeopleX>
  <div class="ai-interview-button-group">
    <button class="btn btn--green btn--header" (click)="importCSVPeopleX()">
      CSV取り込み
    </button>
    <button
      class="btn btn--green btn--header"
      (click)="registerExamResultPeopleX()"
    >
      受検結果登録
    </button>
  </div>
</ng-template>
